/**
 * WeCom Agent - prompt module APIs.
 *
 * Mirrors the guide prompt module contract, but uses the WeCom-specific backend
 * endpoints and table.
 */
import { apiGet, apiPost } from '@/utils/request';
import type { WecomPromptSection, WecomPromptSectionSavePayload } from '@/types/wecomAgent';

export const qywxPromptApi = {
  list: (robotId: number, versionType: number) =>
    apiGet<WecomPromptSection[]>('/qywx/prompt-modules', {
      robot_id: robotId,
      version_type: versionType,
    }),

  save: (robotId: number, versionType: number, items: WecomPromptSectionSavePayload[]) =>
    apiPost<WecomPromptSection[]>('/qywx/prompt-modules/save', {
      robot_id: robotId,
      version_type: versionType,
      items,
    }),
};
